module.exports = __webpack_public_path__ + "src/submodules/base/assets/img/gift-voicemod-logo-mobile.498ff089.svg";